import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FONTS_TO_LOAD, FontsToLoad, WEBCOMPONENT_ROOT_ELEMENT_GETTER, WebComponentRootElementGetter } from '@shared/tokens';
import { type AppComponentInputs } from 'src/app/app.component';

@Injectable({
	providedIn: 'root'
})
export class FontFaceService {
	private static fontsLoaded = false;

	constructor(
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(WEBCOMPONENT_ROOT_ELEMENT_GETTER) private webComponentRootElementGetter: WebComponentRootElementGetter,
		@Inject(FONTS_TO_LOAD) private fontsToLoad: FontsToLoad
	) {}

	load(): Promise<unknown> {
		if (FontFaceService.fontsLoaded) {
			return Promise.resolve();
		}

		return Promise.all(
			this.getFontFaces().map(fontFace => {
				return fontFace.load().then(
					loadedFontFace => this.documentRef.fonts.add(loadedFontFace),
					() => {}
				);
			})
		).then(() => (FontFaceService.fontsLoaded = true));
	}

	private get staticFilesEndpoint(): string {
		return (this.webComponentRootElementGetter() as HTMLElement & AppComponentInputs)?.staticFilesEndpoint || '';
	}

	private getFontFaces(): FontFace[] {
		const staticFilesEndpoint = this.staticFilesEndpoint;
		const url = (fontName: string) => `url(${staticFilesEndpoint}/assets/fonts/${fontName})`;

		return (this.fontsToLoad ?? []).map(font => new FontFace(font.family, url(font.fileName), font.descriptors));
	}
}
